import { Suspense, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import FarmingtonHero from './components/FarmingtonHero';
import FarmingtonTrust from './components/FarmingtonTrust';
import FarmingtonServices from './components/FarmingtonServices';
import FarmingtonNeighborhoods from './components/FarmingtonNeighborhoods';
import FarmingtonTestimonial from './components/FarmingtonTestimonial';
import FarmingtonContact from './components/FarmingtonContact';

export default function FarmingtonPage() {
  useEffect(() => {
    window.scrollTo(0, 0);

    document.title = 'Water Damage Restoration Farmington Utah | 24/7 Emergency Flood Cleanup Services';
    
    const metaTags = [
      { name: 'description', content: 'Expert water damage restoration in Farmington, Utah. 24/7 emergency flood cleanup, mold remediation, and fire damage repair near Station Park & Lagoon. Fast response, certified professionals. Call (385) 340-6632 for immediate assistance.' },
      { name: 'keywords', content: 'water damage restoration Farmington, flood cleanup Farmington Utah, emergency water removal Farmington, mold remediation Farmington, fire damage repair Farmington' },
      { name: 'geo.position', content: '40.9805;-111.8874' },
      { name: 'geo.region', content: 'US-UT' },
      { name: 'geo.placename', content: 'Farmington, Utah' },
      { property: 'og:title', content: 'Water Damage Restoration Farmington Utah | Davis County Disaster Cleanup' },
      { property: 'og:description', content: '24/7 emergency water damage restoration in Farmington. Expert flood cleanup, mold removal, and disaster recovery services.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://daviscountydisastercleanup.com/farmington' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Water Damage Restoration Farmington Utah | Davis County Disaster Cleanup' },
      { name: 'twitter:description', content: '24/7 emergency water damage restoration in Farmington. Expert flood cleanup and disaster recovery.' }
    ];

    metaTags.forEach(({ name, property, content }) => {
      const attr = name ? 'name' : 'property';
      const value = name || property;
      let meta = document.querySelector(`meta[${attr}="${value}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, value as string);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content as string);
    });

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://daviscountydisastercleanup.com/farmington');

    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Do you provide 24/7 emergency water damage restoration in Farmington?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Davis County Disaster Cleanup provides 24/7 emergency water damage restoration services throughout Farmington, Utah. We respond immediately to water emergencies near Station Park, Lagoon, Historic Downtown, and all Farmington neighborhoods."
          }
        },
        {
          "@type": "Question",
          "name": "How quickly can you respond to water damage in Farmington?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We typically arrive within 60 minutes for emergency water damage calls in Farmington. Our local team knows the area well, from Station Park to Farmington Creek, ensuring rapid response times."
          }
        },
        {
          "@type": "Question",
          "name": "What areas of Farmington do you serve?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We serve all of Farmington including Station Park area, Historic Downtown Farmington, Lagoon vicinity, East Farmington, Farmington Creek area, and West Farmington. No location in Farmington is too far for our emergency response team."
          }
        }
      ]
    };

    let script = document.querySelector('script[data-schema="farmington-faq"]');
    if (!script) {
      script = document.createElement('script');
      script.setAttribute('type', 'application/ld+json');
      script.setAttribute('data-schema', 'farmington-faq');
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(faqSchema);

    return () => {
      const schemaScript = document.querySelector('script[data-schema="farmington-faq"]');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return (
    <Suspense fallback={<div className="min-h-screen bg-white"></div>}>
      <div className="min-h-screen bg-white">
        <Navbar />
        <FarmingtonHero />
        <FarmingtonTrust />
        <FarmingtonServices />
        <FarmingtonNeighborhoods />
        <FarmingtonTestimonial />
        <FarmingtonContact />
        <Footer />
      </div>
    </Suspense>
  );
}
